import { Component } from 'react'

import * as h from 'h'

import styles from './styles.scss'

import LabelButtons from 'components/LabelButtons'

/**
 * This component is currently only used by sitewide search, but should be
 * extended to allow NewsStory to use it in the future.
 */

export default class Card extends Component {
  imageColMaybe () {
    const { altTitle, imageUrl, link } = this.props

    return imageUrl && h.div(h.ca(styles.imageCol),
      h.l({ to: link, name: 'expand info' },
        h.img({ src: imageUrl, alt: altTitle, name: '' })))
  }
  render () {
    const { title, labelButtons, link, content, theme } = this.props

    return h.div(h.ca(styles.container),
      h.div(h.ca(styles.inner),
        this.imageColMaybe(),
        h.div(null,
          h.h3(h.ca(styles.title, theme && theme.title),
            h.l({ to: link, name: 'expand info' }, title)),
          h.h(LabelButtons, {data: labelButtons, theme: theme}),
          content,
          this.props.children
        )
      )
    )
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/Card/index.js